import { createSlice } from '@reduxjs/toolkit';
import { initialNotifications } from '../../components/data';

const notificationSlice = createSlice({
  name: 'notifications',
  initialState: {
    items: initialNotifications,
    unreadCount: initialNotifications.filter(n => !n.isRead).length || 4,
  },
  reducers: {
    markAsRead: (state, action) => {
      const notification = state.items.find(n => n.id === action.payload);
      if (notification && !notification.isRead) {
        notification.isRead = true;
        state.unreadCount = state.items.filter(n => !n.isRead).length;
      }
    },

    markAllAsRead: (state) => {
      state.items.forEach(notification => {
        notification.isRead = true;
      });
      state.unreadCount = 0;
    },

    addNotification: (state, action) => {
      state.items.unshift(action.payload);
      if (!action.payload.isRead) {
        state.unreadCount += 1;
      }
    },

    deleteNotification: (state, action) => {
      const deletedItem = state.items.find(n => n.id === action.payload);
      state.items = state.items.filter(n => n.id !== action.payload);
      if (deletedItem && !deletedItem.isRead) {
        state.unreadCount = state.items.filter(n => !n.isRead).length;
      }
    },

    updateNotificationCount: (state, action) => {
      state.unreadCount = action.payload;
    },
  },
});

export const {
  markAsRead,
  markAllAsRead,
  addNotification,
  deleteNotification,
  updateNotificationCount,
} = notificationSlice.actions;

export default notificationSlice.reducer;